import React from 'react';
import { Button } from '@mui/material';
import { Link } from 'react-router-dom';

import { useHasPermissions } from 'hooks/useHasPermissions';
import { FullPageContainer } from 'components/common/Containers';
import ErrorMessage from 'components/common/ErrorMessage';

export default function AuthCheck({
  component: Component,
  permissions,
  everyPermission = false,
  ...componentProps
}) {
  const hasPermissions = useHasPermissions(permissions, everyPermission);

  if (!hasPermissions) {
    return (
      <FullPageContainer>
        <ErrorMessage
          title='Forbidden'
          subtitle="You don't have permissions to see this page"
        >
          <Button component={Link} to='/' variant='contained'>
            Back to home
          </Button>
        </ErrorMessage>
      </FullPageContainer>
    );
  }

  return <Component {...componentProps} />;
}
